import styled from '@emotion/styled';

import React, { CSSProperties, ReactNode } from 'react';

import { observer } from 'mobx-react-lite';

export const ContainerDiv = styled.div`
    padding: 20px;
    margin: 10px;
    border-radius: 10px;
    box-shadow: 0 2px 5px 1px rgba(217, 217, 217, 0.5);
    background-color: white;
`;

export const ContainerTitle = styled.h3`
    margin: 10px 20px 20px 10px;
    font-weight: 600;
`;

interface ContainerProps {
    title?: string;
    className?: string;
    style?: CSSProperties;
    children?: ReactNode;
    testId?: string;
}

export default observer(function Container({
    title,
    className,
    style,
    children,
    testId
}: ContainerProps) {
    return (
        <ContainerDiv className={className} style={style} data-testid={testId}>
            {title && <ContainerTitle>{title}</ContainerTitle>}
            {children}
        </ContainerDiv>
    );
});
